





















































































































































import { Vue, Component } from "vue-property-decorator";
import { required, email } from "vuelidate/lib/validators";
import Password from "vue-password-strength-meter";
import { namespace } from "vuex-class";
import { SignUpPayload } from "../types";
import { loadRecaptcha } from "@/plugins/recaptcha";

const Auth = namespace("auth");
@Component({
  components: {
    password: Password,
  },
})
export default class Signup extends Vue {
  @Auth.Action("signup") signup!: (payload: SignUpPayload) => Promise<{}>;

  loading = false;
  isPasswordStrongEnough = false;
  error = "";
  signUpForm = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    vendorName: "",
  };

  mounted() {
    loadRecaptcha();
  }

  checkScore(score) {
    if (score > 0) {
      this.isPasswordStrongEnough = true;
    }
  }
  submitForm() {
    this.loading = true;
    const {
      firstName,
      lastName,
      email,
      password,
      vendorName,
    } = this.signUpForm;
    
    const grecaptcha = window.grecaptcha;
    
    grecaptcha.ready(() => {
      grecaptcha
        .execute(process.env.VUE_APP_RECAPTCHA_KEY, { action: "signup" })
        .then((token) => {
          this.signup({
            firstName,
            lastName,
            email,
            password,
            vendorName,
            reCaptchaToken : token,
          })
            .then(() => {
              this.loading = false;
              this.$router.push({ name: "verify" });
            })
            .catch((err) => {
              this.loading = false;
              this.error = err.message;
            });
        });
    });
  }
  validations() {
    return {
      signUpForm: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        email: {
          email,
          required,
        },
        password: {
          required,
        },
        vendorName: {
          required,
        },
      },
    };
  }
}
